export default __webpack_public_path__ + "static/media/TFE_mobile_homepage_image.744e5f72.jpg";